@if (_currentTask && !showLoading) {
    <div>
        <b>{{ _currentTask.name }}</b>
        <p>
            @if (_currentTask.brief && _currentTask.brief.length > 1) {
                {{ _currentTask.brief }}
            } @else {
                <span class="gray-text"><i>No brief</i></span>
            }
        </p>
        <b>Status</b>
        <div class="hcol-flex gap-half align-center">
            @let statusTag = TaskUtils.statusTagsByStatus[_currentTask.status];
            <p-tag
                [icon]="statusTag.icon"
                [style]="statusTag.style!"
                [value]="statusTag.label"
                [rounded]="false"
                [pTooltip]="statusTag.tooltip"
            ></p-tag>

            @if (currentTaskIsOutdatedFailed) {
                <p-tag
                    [icon]="TaskUtils.outdatedFailedTag.icon"
                    [style]="TaskUtils.outdatedFailedTag.style!"
                    [value]="TaskUtils.outdatedFailedTag.label"
                    [rounded]="false"
                    [pTooltip]="TaskUtils.outdatedFailedTag.tooltip"
                ></p-tag>
            } @else if (currentTaskIsOutdated) {
                <p-tag
                    [icon]="TaskUtils.outdatedTag.icon"
                    [style]="TaskUtils.outdatedTag.style!"
                    [value]="TaskUtils.outdatedTag.label"
                    [rounded]="false"
                    [pTooltip]="TaskUtils.outdatedTag.tooltip"
                ></p-tag>
            }

            <p-button
                [style.margin-left]="'0.5rem'"
                [disabled]="!_canEditStatus"
                (click)="editStatus()"
                (keydown.enter)="editStatus()"
                size="small"
                severity="contrast"
                icon="pi pi-pencil"
            />
        </div>
        @for (option of _options; track option.tag) {
            <b>{{ option.title }}</b>
            <p>
                <p-checkbox
                    [style.margin-right]="'0.5rem'"
                    [binary]="true"
                    [(ngModel)]="option.checked"
                    [disabled]="!_canEditTask"
                    [inputId]="option.tag"
                    (onChange)="onOptionChanged(option)"
                />
                <label [for]="option.tag" class="ml-2">{{ option.label }}</label>
            </p>
        }
        <div style="display: flex; gap: 2rem; margin-bottom: 1rem">
            <div style="flex: 1">
                <b>Due Date</b>
                <p>
                    @if (_currentTask.due_date) {
                        {{ _currentTask.due_date | date: SDKConfig.dateFormat }}
                    } @else {
                        <span class="gray-text"><i>No due date</i></span>
                    }
                    <p-button
                        [style.margin-left]="'0.5rem'"
                        [disabled]="!_canEditDueDate"
                        (click)="editDueDate()"
                        (keydown.enter)="editDueDate()"
                        size="small"
                        severity="contrast"
                        icon="pi pi-pencil"
                    />
                </p>
            </div>
            <div style="flex: 1">
                <b>Start Date</b>
                <p>
                    @if (_currentTask.start_date) {
                        {{ _currentTask.start_date | date: SDKConfig.dateFormat }}
                    } @else {
                        <span class="gray-text"><i>No start date</i></span>
                    }
                    <p-button
                        [style.margin-left]="'0.5rem'"
                        [disabled]="!_canEditStartDate"
                        (click)="editStartDate()"
                        (keydown.enter)="editStartDate()"
                        size="small"
                        severity="contrast"
                        icon="pi pi-pencil"
                    />
                </p>
            </div>
            <div style="flex: 1">
                <b>End date</b>
                <p>
                    @if (_currentTask.end_date) {
                        {{ _currentTask.end_date | date: SDKConfig.dateFormat }}
                    } @else {
                        <span class="gray-text"><i>No end date</i></span>
                    }
                    <p-button
                        [style.margin-left]="'0.5rem'"
                        [disabled]="!_canEditEndDate"
                        (click)="editEndDate()"
                        (keydown.enter)="editEndDate()"
                        size="small"
                        severity="contrast"
                        icon="pi pi-pencil"
                    />
                </p>
            </div>
        </div>
        <b>Dependencies</b>
        <div [ngStyle]="{'margin-left': '1rem'}">
            <p>
                @if (_currentTask.dependency_relationships?.length !== 0) {
                    <b>Parents tasks (Predecessors)</b>
                    @for (dependency of _currentTaskDependencies; track dependency) {
                        @if (dependency) {
                            <br />
                            <a
                                tabindex="0"
                                role="button"
                                (click)="selectTask(dependency.uuid)"
                                (keydown.enter)="selectTask(dependency.uuid)"
                                (keydown.space)="$event.preventDefault(); selectTask(dependency.uuid)"
                                [ngStyle]="{'margin-left': '1rem'}"
                            >
                                {{ dependency.name }}</a
                            >
                        }
                    }
                } @else {
                    <span class="gray-text"><i>No parents tasks</i></span>
                }
            </p>
            <p>
                @if (_currentTaskDependants.length !== 0) {
                    <b>Child tasks (Successors)</b>
                    @for (dependant of _currentTaskDependants; track dependant) {
                        @if (dependant) {
                            <br />
                            <a
                                tabindex="0"
                                role="button"
                                (click)="selectTask(dependant.uuid)"
                                (keydown.enter)="selectTask(dependant.uuid)"
                                (keydown.space)="$event.preventDefault(); selectTask(dependant.uuid)"
                                [ngStyle]="{'margin-left': '1rem'}"
                            >
                                {{ dependant.name }}</a
                            >
                        }
                    }
                } @else {
                    <span class="gray-text"><i>No childs tasks</i></span>
                }
            </p>
        </div>
        @if (
            _currentTask.task_type === ECpmCTaskTypeApiEnum.SMART &&
            _currentTask.plugin_id &&
            _currentTask.plugin_function_id
        ) {
            <b>Inputs</b>
            <div>
                <app-action-jobs-function-io-editor
                    side="input"
                    [taskLabel]="_currentTask.name"
                    [plugin]="_selectedPlugin"
                    [pluginFunction]="_selectedPluginFunction"
                    [iosMapping]="_inputsMappings"
                    [readOnly]="!_canEditTask"
                    [noFrame]="true"
                    [noSeparator]="true"
                    [objectStoreEntriesTransientCache]="_objectStoreEntriesTransientCache"
                    [inputChangeConfirmation]="shouldWarnResetOnChange ? _taskInputChangeConfirmation : undefined"
                    [persistMappingsAsync]="persistInputMappingsFromEditor"
                    (validityChangedEvent)="_inputsMappingValid = $event"
                    (changedEvent)="onInputsChanged($event)"
                ></app-action-jobs-function-io-editor>
            </div>

            <b>Outputs</b>
            <div>
                <app-action-jobs-function-io-editor
                    side="output"
                    [taskLabel]="_currentTask.name"
                    [plugin]="_selectedPlugin"
                    [pluginFunction]="_selectedPluginFunction"
                    [iosMapping]="_outputsMappings"
                    [readOnly]="!_canEditTask"
                    [noFrame]="true"
                    [noSeparator]="true"
                    [objectStoreEntriesTransientCache]="_objectStoreEntriesTransientCache"
                    (validityChangedEvent)="_outputsMappingValid = $event"
                    (changedEvent)="onMappingsChanged()"
                ></app-action-jobs-function-io-editor>
            </div>
        }
    </div>
} @else if (showLoading) {
    <div style="text-align: center">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
        <div class="gray-text centered-text mt-2 mb-2">Task is loading, please wait.</div>
    </div>
} @else {
    <p class="gray-text centered-text mt-4 mb-4">
        No task selected, please select a task first!<br /><span class="pi pi-arrow-left"></span>
    </p>
}
